export default function Filter() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77665 19.9743C8.42339 19.9743 8.12728 19.8548 7.88831 19.6158C7.64934 19.3769 7.52986 19.0808 7.52986 18.7275V11.2468L0.298465 2.0205C-0.0132328 1.6049 -0.0599875 1.16853 0.158201 0.71137C0.376389 0.254213 0.755622 0.0256348 1.2959 0.0256348H18.751C19.2913 0.0256348 19.6705 0.254213 19.8887 0.71137C20.1069 1.16853 20.0601 1.6049 19.7484 2.0205L12.517 11.2468V18.7275C12.517 19.0808 12.3975 19.3769 12.1586 19.6158C11.9196 19.8548 11.6235 19.9743 11.2702 19.9743H8.77665ZM10.0234 10.374L16.1951 2.51922H3.85182L10.0234 10.374Z"
        className="fill-main-black"
      />
    </svg>
  )
}
